module.exports = __webpack_public_path__ + "static/media/zoleWon_25000_50000.0b6e107c.png";